import React from "react";
import { downloadFormatType, downloadUrlType } from "../../common/types/search/search";

interface DownloadLinkProps {
	format: downloadFormatType;
	label: string;
	getDownloadUrl: downloadUrlType;
	onLinkClick: () => void;
	classes?: string;
}

export function DownloadLink({
	format,
	label,
	getDownloadUrl,
	onLinkClick,
	classes = "",
}: DownloadLinkProps) {
	const { type } = format;

	const extraParameters = format.options
		? {
				csv_delimiter: format.options.csv_delimiter,
			}
		: {};

	const downloadUrl = getDownloadUrl(type, extraParameters);

	return (
		<a
			href={downloadUrl}
			target="_blank"
			className={classes}
			onClick={onLinkClick}
			rel="noreferrer"
		>
			<span>{label}</span>
		</a>
	);
}
